import DadosContainer from './dados.container'

export default DadosContainer
